import Axios, { AxiosRequestConfig } from "axios";
import { ObjectUtils } from "../modules/utils";
import { store } from "../store/store";
import { SET_FORBIDDEN_ERROR, SET_UNAUTHORIZED_ERROR } from "./main/main.reducer";
import { getDeviceId } from "../pages/document/util";
import { UAParser } from "ua-parser-js";
const api = Axios.create({
  timeout: 20000,
});

const authHeader = async (config: AxiosRequestConfig) => {
  const { method } = config;
  const deviceId = await getDeviceId();
  const parser = new UAParser();
  const result = parser.getResult();

  const userToken = store.getState().user?.current?.accessToken;

  // DEBUG: Log token info
  if (config.url?.includes("graph.microsoft.com")) {
    console.log("Graph Request:", config.url);
    if (!userToken) console.error("❌ Host: Missing Token");
    else console.log("✅ Host: Token Present, Length:", userToken.length);
  }

  let headers = ObjectUtils.cleanObj({
    Authorization: `Bearer ${userToken}`,
    Prefer: "HonorNonIndexedQueriesWarningMayFailRandomly",
    X_DEVICE_UDID: deviceId || "",
    X_APP_NAME: result.browser.name || "",
    X_APP_VERSION: "",
    X_APP_BUILD: "",
    X_DEVICE_OS: result.os.version || "",
    X_DEVICE_PLATFORM: result.os.name || "",
    X_DEVICE_MODEL: result.device.model || "",
    X_DEVICE_NAME: result.browser.name || "",
    X_DEVICE_LOCATION: "",
    X_APP_LANGUAGE: navigator.language || "en-US",
  });
  if (method === "post" || method === "patch") {
    headers = { ...headers, "Content-Type": "application/json" };
  }
  return headers;
};

api.interceptors.request.use(async (config) => {
  config.headers = await authHeader(config);
  return config;
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      store.dispatch({
        type: SET_UNAUTHORIZED_ERROR,
        status: true,
      });
    } else if (error.response.status === 403) {
      store.dispatch({
        type: SET_FORBIDDEN_ERROR,
        status: true,
      });
    }
    return Promise.reject(error);
  },
);

export default api;
